<template>
<div class="addsite">
    <!--头部-->
    <!--<van-nav-bar title="添加收货地址" fixed left-arrow @click-left="goBack"></van-nav-bar>-->
    <div style="padding-top: 0" class="van-content">
      <van-cell-group style="margin-bottom: 0">
        <van-field v-model="name" placeholder="请输入收货人" label="收货人："/>
        <van-field v-model="mobile" placeholder="请输入手机号码" label="手机号码："/>
        <van-field v-model="sitedDatasName" placeholder="选择地址" readonly label="省市区：" @click="cityPickershow"/>
        <van-field v-model="setess" placeholder="" label="详细地址："/>
      </van-cell-group>
      <van-cell-group class="hasBorder">
        <van-cell title="设为默认">
          <van-checkbox v-model="checked"/>
        </van-cell>
      </van-cell-group>
      <div style="margin-top: 50px" class="addSiteBtn">
        <van-button size="large" class="addSiteBtn theme-bd theme-bg" @click="sendDatas">保存地址</van-button>
      </div>
    </div>
    <!--地址选择弹框-->
    <City-Picker ref="CityPicker" v-on:listenSitedata="geSitedatas"></City-Picker>
</div>
</template>

<script>
  import CityPicker from '@/pages/user/mysite/cityPicker'
  export default {
    name: "addsite",
    components: {
      CityPicker
    },
    data () {
      return {
        sitedDatas:'',
        sitedDatasName:'',
        checked:false,//设为默认
        name:'',//收货人
        mobile:'',//手机号
        site:'',//省市区
        setess:'',//详细地址
        province:'',
        city:'',
        town:'',
        county:''
      }
    },
    methods:{
      cityPickershow:function () {
        this.$refs.CityPicker.cityPickershow()
      },
      geSitedatas:function (datas) {
        this.sitedDatasName = ''
        this.sitedDatas = datas
        if(datas[0].id != undefined){
          this.sitedDatasName += datas[0].name
          this.province = datas[0].id
        }
        if(datas[1].id != undefined){
          this.sitedDatasName += "-"+datas[1].name
          this.city = datas[1].id
        }
        if(datas[2].id != undefined){
          this.sitedDatasName += "-"+datas[2].name
          this.town = datas[2].id
        }
        if(datas[3].id != undefined){
          this.sitedDatasName += "-"+datas[3].name
          this.county = datas[3].id
        }
      },
      goBack: function () {
        history.back(-1);
      },
      sendDatas:function () {
        var isUser = localStorage.getItem("BLHuser")
        var _this = this
        var moren = 0
        if(this.checked == true){
          moren = 1
        }else{
          moren = 0
        }
        this.$api.get('WebApi/Member/Address/setAddrItem', {token:isUser,moren:moren,name:this.name,mobile:this.mobile,address:this.setess,province:this.province,province:this.province,city:this.city,town:this.town,county:this.county}, res => {
          if(res.data.errCode == '0000'){
            this.goBack()
          }else{
            this.$toast(res.data.desc)
          }
        })
      }
    },
    mounted () {

    },
  }
</script>

<style lang="less" scoped>
  .addsite{
    .van-cell-group{
      background-color: #fff;
    }
    .addSiteBtn{
      border-right: 0;
      width: 100%;
      padding: 0 15px;
      box-sizing: border-box;
      button{
        border-radius: 6px;
        border: none;
        width: 100%;
        float: left;
      }
    }
    .hasBorder{
      position: relative;
    }
    .hasBorder:before{
      position: absolute;
      top:0;
      right: 0;
      left:15px;
      content: '';
      height: 0.5px;
      width: 100%;
      -webkit-transform: scaleY(.5);
      transform: scaleY(.5);
      background-color: #e5e5e5;
      z-index: 100;
    }
    .van-icon.van-icon-success{
      color: #fff!important;
    }
    .van-checkbox__icon--checked .van-icon {
      border-color: #D7000A!important;
      background-color: #D7000A!important;
    }


  }
</style>



// WEBPACK FOOTER //
// src/pages/user/mysite/addsite.vue